import React from 'react';

export const Loading = () => {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{height: '200px'}}>
      <div className="spinner-border" role="status">
        <span>Загрузка...</span>
      </div>
    </div>
  );
};

export const Error = ({error}) => {
  console.log(error.message);
  return (
    <div className="p-4 text-center">
      {error.message.includes('matching query does not exist.') ? 'Не найдено' : 'Ошибка'}
    </div>
  );
};

export const EmptyList = () => {
  return <div className="p-4 text-center">Список пуст.</div>;
};

const Query = ({loading, error, data}) => {
  const target = data ? data[Object.keys(data)[0]] : null;

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;
  if (!target) return null;
  if (Array.isArray(target) && !target.length) return <EmptyList />;
  return null;
};

export default Query;
